var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"VideoParser"}},[_c('video',{staticClass:"img-fluid animate__animated animate__fadeIn",attrs:{"autoplay":_vm.autoplay,"poster":"/img/video_backgrounds/purple.jpg","src":_vm.content,"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }